module.exports = __webpack_public_path__ + "img/使用教程.365e9dc2.svg";